//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import dragVerify from '../../common/dragVerify'
import puzzle from "../../common/puzzle.vue";
export default {
  components: {
    // dragVerify,
    puzzle: puzzle
  },
  data: function data() {
    return {
      form: {
        phone: "",
        code: ''
      },
      rules: {
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[23456789]\d{9}$/,
          message: '目前只支持中国大陆的手机号码'
        }]
      },
      auth_time: "获取验证码",
      sendAuthCode: false,
      snackbar: false,
      message: "",
      ispass: true
    };
  },
  computed: {},
  watch: {},
  methods: {
    onMpanelSuccess: function onMpanelSuccess() {
      this.ispass = false;
      //执行代码
    },
    send: function send() {
      var ctrl = this;
      ctrl.$refs["form"].validate(function (valid) {
        function getAuthCode() {
          ctrl.sendAuthCode = true;
          ctrl.auth_time = 60;
          var auth_timetimer = setInterval(function () {
            ctrl.auth_time--;
            if (ctrl.auth_time <= 0) {
              ctrl.sendAuthCode = false;
              ctrl.auth_time = "发送验证码";
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
        if (valid) {
          Lib.M.ajax({
            'method': "get",
            'url': "user/sendMsg/".concat(ctrl.form.phone),
            'success': function success(data) {
              getAuthCode();
              ctrl.$store.dispatch("dispatchIsLogin", 1);
              ctrl.$message.success(data.userInfo);
            },
            "error": function error(data) {
              ctrl.message = data.userInfo;
              ctrl.showSnackbar();
            }
          });
        } else {
          return;
        }
      });
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        var self = this;
        Lib.M.ajax({
          'method': "POST",
          'url': 'user/login',
          'params': {},
          'data': {
            tel: self.form.phone,
            pwd: self.form.code,
            loginType: 1,
            accessType: 1
          },
          'success': function success(data) {
            self.isShowProgress = false;
            if (data.code == "20000000") {
              sessionStorage.setItem("roles", JSON.stringify(data.obj.auditUserTypes));
              sessionStorage.setItem("data", JSON.stringify(data.obj.user));
              sessionStorage.setItem("token", JSON.stringify(data.obj.token));
              localStorage.setItem("token", JSON.stringify(data.obj.token));
              self.$upload.defaults.headers.common["token"] = data.obj.token.tokenId;
              sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
              sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
              sessionStorage.setItem("menuEng", JSON.stringify(data.obj.menuEng));
              sessionStorage.setItem("permissionEng", JSON.stringify(data.obj.permissionEng));
              self.$store.dispatch("dispatchIsLogin", 1);
              setTimeout(function () {
                //审计人员登录跳转到其他页面
                if (data.obj.user.roles[0].roleId === 'role-20250808112144-91jz607e') {
                  self.$router.push("/main/bidMarketList");
                } else {
                  if (data.obj.user.dept.branchUnitId) {
                    if (data.obj.user.dept.branchUnitId === 'dept-20230209092043-mq40sqtk' || data.obj.user.dept.branchUnitId === 'dept-20190923113717-1j4004gd') {
                      self.$router.push("/main/international/dataScreening");
                    } else {
                      self.$router.push("/main/dataScreening");
                    }
                  } else {
                    self.$router.push("/main/dataScreening");
                  }
                }
              }, 500);
            } else {
              self.message = data.msg;
              self.showSnackbar();
            }
          },
          "error": function error(data) {
            self.isShowProgress = false;
            self.message = data.userInfo;
            self.showSnackbar();
          }
        });
      }
    }
  }
};